import { Component, computed, input, linkedSignal, output } from '@angular/core';

import { companyInitials } from './company-initials';

/**
 * A company's logo, or its initials when it has none (or the image cannot be
 * loaded). It fills whatever tile holds it; the tile sets size, colour and clipping.
 */
@Component({
  selector: 'app-company-mark',
  host: { class: 'contents' },
  template: `
    @if (showLogo()) {
      <img
        class="block h-full w-full object-contain p-[3px]"
        alt=""
        [src]="logoUrl()"
        (error)="onError()"
      />
    } @else {
      {{ initials() }}
    }
  `,
})
export class CompanyMarkComponent {
  readonly logoUrl = input<string | null>(null);
  readonly name = input.required<string>();
  /** The image could not be loaded, usually because its signed link has expired. */
  readonly logoFailed = output<void>();

  /** A new URL gets a fresh try; a broken one falls back to the initials. */
  protected readonly failed = linkedSignal(() => {
    this.logoUrl();
    return false;
  });
  protected onError(): void {
    this.failed.set(true);
    this.logoFailed.emit();
  }

  protected readonly showLogo = computed(() => !!this.logoUrl() && !this.failed());
  protected readonly initials = computed(() => companyInitials(this.name()));
}
